import { render, staticRenderFns } from "./AboutCompany.vue?vue&type=template&id=0dd87754&"
import script from "./AboutCompany.vue?vue&type=script&lang=js&"
export * from "./AboutCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports